<div class="wrapper">
    <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <div class="advancedSearch">
                <button type="button" mat-raised-button>
                    <span><mat-icon svgIcon="filter"></mat-icon></span>
                    <span>Advanced Search</span> 
                </button>
            </div>

        </div>
        <div class="cal-xl-6 col-lg-6 col-md-12 col-sm-12">
            <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div>
        <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
            <div class="button-group">
                <button type="button" (click)="createLeave()" class="btn-int-blue" mat-raised-button>create Leave</button>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="mat-table-responsive">
                <table mat-table [dataSource]="leavesDataSource">

                    <ng-container matColumnDef="org_name">
                        <th mat-header-cell *matHeaderCellDef>Organization </th>
                        <td mat-cell *matCellDef="let element"> {{(element.org_name != null)? element.org_name :" - "}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leave_type_name">
                        <th mat-header-cell *matHeaderCellDef> Leave Type </th>
                        <td mat-cell *matCellDef="let element"> {{element.leave_type_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leaves_for_year">
                        <th mat-header-cell *matHeaderCellDef> Year </th>
                        <td mat-cell *matCellDef="let element"> {{element.leaves_for_year}} </td>
                    </ng-container>

                    <ng-container matColumnDef="leaves">
                        <th mat-header-cell *matHeaderCellDef>Leaves </th>
                        <td mat-cell *matCellDef="let element"> {{element.leaves}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns | tableShowColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns| tableShowColumns;"></tr>
                </table>
                <ng-container *ngIf="leavesDataSource?.filteredData?.length == 0">
                    <div class="row forNoRecords">
                        <h3 class="table-no-date"> No Record found</h3>
                    </div>
                </ng-container>
                <app-table-loader></app-table-loader>
            </div>

        </div>
    </div>
</div>